import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useCarrito } from "../context/CarritoContext";
import { toast } from "react-toastify";

export default function ProductCard({ product, isAdmin }) {
  const navigate = useNavigate();
  const { agregarAlCarrito, setEstaMinimizado } = useCarrito();

  const handleClick = () => navigate(`/producto/${encodeURIComponent(product.sku)}`);

  const handleAddToCart = (e) => {
    e.stopPropagation();

    agregarAlCarrito({
      ...product,
      cantidad: 1,
    });
  };

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      className="bg-white border border-gray-200 rounded-2xl shadow-xl overflow-hidden transition-all duration-300 cursor-pointer"
    >
      <div
        className="w-full h-52 bg-white flex items-center justify-center overflow-hidden"
        onClick={handleClick}
      >
        <motion.img
          loading="lazy"
          src={product.imagen}
          alt={product.nombre}
          className="max-h-full object-contain"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        />
      </div>
      <div className="p-4">
        <h3 className="font-bold text-[#40767b]">{product.nombre}</h3>
        <p className="text-sm text-gray-600 line-clamp-2">{product.descripcion}</p>

        {!isAdmin && (
          <button
            onClick={(e) => {
              handleAddToCart(e);
              toast.success("Producto agregado al carrito");
            }}
            className="w-full mt-4 px-6 py-3 flex items-center justify-center rounded-full text-lg font-medium bg-white text-[#40767b] ring-1 ring-[#b5d2d5] hover:bg-[#f4fbfc] hover:text-[#2d4f51] hover:ring-[#90bfc4] shadow-sm hover:shadow-lg transition"
          >
            Cotizar
          </button>
        )}
      </div>
    </motion.div>
  );
}

